import {ChangeDetectionStrategy, Component, computed, input, output, signal} from '@angular/core';
import {AppContext} from "../../../../../app-context";
import lodash from "lodash";
import {CheckboxSelectionState, nonNull, openEditModal} from "../../../../../common/utils";
import {
  EquipmentConsignmentDetailsComponent,
  EquipmentConsignmentDetailsComponentData
} from "../../../details/equipment-consignment-details/equipment-consignment-details.component";
import {ConsignmentUtils, EquipmentSummaryItem} from "../../../consignment.utils";
import {DeclarationMessageStatus} from "../../../../visit-overview/visit-overview-item/visit-overview.utils";
import {IE3GoodsItemSummary, TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-consignment-equipment-overview-item',
    templateUrl: './consignment-equipment-overview-item.component.html',
    styleUrls: ['./consignment-equipment-overview-item.component.scss', '../master-consignment-overview-item.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConsignmentEquipmentOverviewItemComponent {
  utils = ConsignmentUtils;
  appContext = AppContext;

  readonly equipment = input.required<EquipmentSummaryItem>();
  readonly consignmentProcessId = input<string>();
  readonly term = input<string>();
  readonly selectable = input<boolean>();
  readonly collapsible = input<boolean>();
  readonly selected = input<boolean>(false);

  readonly highlighted = output<string>();
  readonly selectionToggled = output<void>();
  readonly checkboxSelectionState = CheckboxSelectionState;

  selectionWidth: number = 40;

  collapsed = signal(false);

  readonly dischargedStatus = computed(() => this.getDischargedStatus());
  readonly inspectionStatus = computed(() => this.getInspectionStatus());
  readonly terminalStatuses = computed(() => [this.dischargedStatus(), this.inspectionStatus()].filter(nonNull)
    .filter(a => a.taskStatus !== TaskMessageStatus.DISABLED));
  readonly goods = computed(() => this.equipment().goodsItems.map(g => g.goodsItem));
  readonly totalWeight = computed(() => lodash.round(lodash.sum(this.equipment().goodsItems.map(g => g.placement.grossWeight)), 1));

  editEquipment = () => openEditModal(EquipmentConsignmentDetailsComponent, <EquipmentConsignmentDetailsComponentData>{
    consignmentProcessId: this.consignmentProcessId(),
    equipmentNumber: this.equipment().equipment.equipmentNumber
  }, {
    warnOnClose: true,
    currentToStack: true
  });

  private getDischargedStatus = (): DeclarationMessageStatus =>
    ConsignmentUtils.getDischargedStatus(this.equipment().equipment.dischargeStatus);

  private getInspectionStatus = (): DeclarationMessageStatus =>
    ConsignmentUtils.getInspectionsStatus([lodash.last(this.equipment().equipment.inspections)]);

  onHighlightMatch() {
    this.highlighted.emit(this.equipment().equipment.equipmentNumber);
  }
}
